module.exports = __webpack_public_path__ + "static/img/b5.d205dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b5.png
// module id = 8SBb
// module chunks = 1